export default __webpack_public_path__ + "static/media/logo.817bbb46.svg";